import { useState } from 'react'

import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useAppContext } from 'contexts/app-context/hooks'
import { Routes } from 'common/constants'

export function useHelpCenterButton() {
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const { userSelectedEntity } = useAppContext()

  const onClick = async () => {
    try {
      await sendSelectContent({
        flow: 'home',
        step: 'home',
        screen_name: Routes.HOME,
        element_name: 'selectHelpCenter',
        element_type: 'button',
        parent_name: 'Home',
        scenario: JSON.stringify({
          screen: Routes.HOME,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send help center tic', error)
    }

    setShowBottomSheet((prev) => !prev)
  }

  return { onClick, showBottomSheet }
}
